import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import PropTypes from "prop-types";
import { CalendarOptionImpl } from "./calendar-option.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  external: PropTypes.bool,
  highlighted: PropTypes.bool,
  onHighlight: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  value: PropTypes.instanceOf(Date).isRequired
};
const CalendarOption = ({
  children,
  external = false,
  highlighted = false,
  onHighlight,
  onSelect,
  selected = false,
  value,
  ...restProps
}) => {
  const handleClick = useCallback(() => {
    onSelect(value);
  }, [onSelect, value]);
  const handleMouseEnter = useCallback(() => {
    onHighlight(value);
  }, [onHighlight, value]);
  const handleMouseLeave = useCallback(() => {
    onHighlight(void 0);
  }, [onHighlight]);
  return /* @__PURE__ */ jsx(
    CalendarOptionImpl,
    {
      role: "option",
      "aria-checked": Boolean(selected),
      "aria-selected": Boolean(highlighted),
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      $external: external,
      $highlighted: highlighted,
      $selected: selected,
      ...restProps,
      children
    }
  );
};
CalendarOption.propTypes = propTypes;
export {
  CalendarOption
};
